import { collection, addDoc, Timestamp, doc, getDoc } from "firebase/firestore";
import { auth, db } from "../config/firebase";

// Action types for history logging (duplicated here to avoid circular dependency)
export const ACTION_TYPES = {
  ASSIGNED: "assigned",
  RETURNED: "returned",
  DELETED: "deleted",
  AMOUNT_CHANGED: "amount_changed",
  SEEN: "seen",
  CREATED: "created",
  UPDATED: "updated",
  MADE_AVAILABLE: "made_available",
};

/**
 * Utility function to log activities to history
 * Can be used anywhere without requiring hooks
 */
export const logActivity = async ({
  actionType,
  itemId,
  itemName,
  serialNumber = null,
  details = {},
  metadata = {},
}) => {
  try {
    const fu = auth.currentUser;
    const userEmail = fu?.email || "";
    if (!userEmail) {
      console.warn("Cannot log activity: No signed-in user");
      return { success: false, error: "No user" };
    }

    let userPermissions = "childUser";
    let userEmployeeId = "";
    const userDoc = await getDoc(doc(db, "users", userEmail));
    if (userDoc.exists()) {
      const d = userDoc.data();
      userPermissions = d.permissions || "childUser";
      userEmployeeId = d.employeeId || "";
    }

    const userId = userEmail;
    const userName = userEmail ? userEmail.split("@")[0] : "משתמש";

    const historyRef = collection(db, "history");
    const activityData = {
      timestamp: Timestamp.now(),
      userId,
      userName, // Keep for backward compatibility (email local part)
      userEmail: userEmail || null, // Full email for resolving display name via users/personnel
      userEmployeeId, // Store employeeId to fetch name later
      actionType,
      itemId,
      itemName,
      serialNumber,
      details,
      metadata: {
        ...metadata,
        userRole: userPermissions || "childUser",
      },
    };

    await addDoc(historyRef, activityData);
    return { success: true };
  } catch (e) {
    console.error("Error logging activity: ", e);
    return { success: false, error: e.message };
  }
};

/**
 * Helper function to get unit name from units array
 */
export const getUnitNameFromUnits = (unitId, units = []) => {
  const unit = units.find((u) => u.id === unitId);
  return unit?.name || "";
};

/**
 * Helper function to get personnel name from personnel array
 */
export const getPersonnelName = (personalNumber, personnel = []) => {
  const person = personnel.find((p) => p.personalNumber === personalNumber);
  return person ? `${person.firstName} ${person.lastName}` : "";
};
